import { memo, useEffect } from 'react';
import { Layer, Source, useMap } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { PATH_ARROW_LAYER_STYLE, PATH_LAYER_STYLE, PATH_POINTS_LAYER_STYLE } from '../../../constants/map';
import { capturingTimelineSelectedPath } from '../../../storage/streaming';

function CapturingTimelinePathLayer() {
  const { map } = useMap();
  const path = useRecoilValue(capturingTimelineSelectedPath);

  useEffect(() => {
    if (!map) return;
    const arrowUrl = '/img/icons/map/arrow.png';
    map.loadImage(`${arrowUrl}`, (error, image) => {
      if (error) {
        return;
      }
      if (image && !map.hasImage('arrow')) {
        map.addImage('arrow', image);
      }
    });
  }, [map]);

  if (!path) return null;

  const lineString: GeoJSON.LineString & { properties: { uuid: string } } = {
    type: 'LineString',
    coordinates: path,
    properties: {
      uuid: 'myuid',
    },
  };

  if (!lineString) return null;

  return (
    <Source
      type="geojson"
      data={lineString}
      id={`path-source`}
    >
      <Layer
        {...PATH_LAYER_STYLE}
        id={`path-layer`}
        paint={{
          'line-color': 'red',
          'line-width': 8,
        }}
      />
      <Layer
        {...PATH_ARROW_LAYER_STYLE}
        id={`path-arrow-layer`}
      />
      <Layer
        {...PATH_POINTS_LAYER_STYLE}
        id={`path-points-layer`}
        paint={{
          'circle-color': '#ffffff',
          'circle-radius': 2.5,
          'circle-stroke-color': 'red',
          'circle-stroke-width': 4,
        }}
      />
    </Source>
  );
}

export default memo(CapturingTimelinePathLayer);
